import { React, useEffect, useState, forwardRef, useImperativeHandle, useLayoutEffect } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import SearchInput from '../../../Component/MemberComponent/SearchInput.js';
import InfoPagination from '../../../Component/MemberComponent/InfoPagination.js';

import ExpiredColumnView from './ExpiredColumnView.js';
import ExpiredMemberInfo from './ExpiredMemberInfo.js';

import SortingModule from '../../Share/Normal/SortingModule.js';

import { ReactComponent as DefaultLogoSvg } from '../../../image/DefaultLogo.svg';
import LoadingAnimation from '../../../Animation/NewLoading.json';


const ExpiredMemberView = forwardRef((props, ref) => {
  const { data, isLoading } = props;
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [totalData, setTotalData] = useState(data);
  const [sortingData, setSortingData] = useState([]);
  const [dividedData, setDividedData] = useState([]);
  const [nowPage, setNowPage] = useState(0);
  const [value, setValue] = useState('');

  const [selectedMembership, setSelectedMembership] = useState([]);
  const [genderSort, setGenderSort] = useState('normal');
  const [birthSort, setBirthSort] = useState('normal');
  const [startSort, setStartSort] = useState('normal');
  const [endSort, setEndSort] = useState('desc');
  const [classSort, setClassSort] = useState('normal');

  const [isSettled, setIsSettled] = useState(false);

  useLayoutEffect(() => { setIsSettled(false); }, [data]);

  useImperativeHandle(ref, () => ({
    setData: (val) => {
      setTotalData(val);
    }
	}))

  // 페이지 복원 //
  useEffect(() => {
    setNowPage(window.localStorage.getItem('InvalidMemberPage') === null ? 0 : parseInt(window.localStorage.getItem('InvalidMemberPage')));
  }, [])

  // 소팅 상태 복원 //
  useEffect(() => {
    let prevGenderSort = window.localStorage.getItem('InvalidMemberGenderSort');
    let prevBirthSort = window.localStorage.getItem('InvalidMemberBirthSort');
    let prevStartSort = window.localStorage.getItem('InvalidMemberStartSort');
    let prevEndSort = window.localStorage.getItem('InvalidMemberEndSort');
    let prevClassSort = window.localStorage.getItem('InvalidMemberClassSort');
    let prevMembershipNames = window.localStorage.getItem('InvalidMemberMembershipNames');

    if (prevGenderSort !== null) setGenderSort(prevGenderSort);
    if (prevBirthSort !== null) setBirthSort(prevBirthSort);
    if (prevStartSort !== null) setStartSort(prevStartSort);
    if (prevEndSort !== null) setEndSort(prevEndSort);
    if (prevClassSort !== null) setClassSort(prevClassSort);
    if (prevMembershipNames !== null && prevMembershipNames !== '') {
      let selectedMemberships = [];

      prevMembershipNames = prevMembershipNames.split('<-@->');
      prevMembershipNames.map((data) => selectedMemberships.push({ name: data }));

      setSelectedMembership(selectedMemberships);
    }
  }, [])

  // 회원 정보 소팅 //
  useEffect(() => {
    let newData = totalData.slice();
    
    if (selectedMembership.length !== 0) {
      let tmpNewData = [];
      
      for (let i = 0; i < newData.length; i++) {
        for (let j = 0; j < selectedMembership.length; j++) {
          if (selectedMembership[j].name === newData[i].memberShipName) {
            tmpNewData.push(newData[i]);
          }
        }
      }

      newData = tmpNewData;
    }

    if (genderSort === 'asc') newData = SortingModule.dataSort(newData, 'gender', 'asc', 'gender');
    else if (genderSort === 'desc') newData = SortingModule.dataSort(newData, 'gender', 'desc', 'gender');
    else if (birthSort === 'asc') newData = SortingModule.dataSort(newData, 'birthDay', 'asc', 'birthDay');
    else if (birthSort === 'desc') newData = SortingModule.dataSort(newData, 'birthDay', 'desc', 'birthDay');
    else if (startSort === 'asc') newData = SortingModule.dataSort(newData, 'startDate', 'asc', 'startDate');
    else if (startSort === 'desc') newData = SortingModule.dataSort(newData, 'startDate', 'desc', 'startDate');
    else if (endSort === 'asc') newData = SortingModule.dataSort(newData, 'endDate', 'asc', 'endDate');
    else if (endSort === 'desc') newData = SortingModule.dataSort(newData, 'endDate', 'desc', 'endDate');
    else if (classSort === 'asc') newData = SortingModule.dataSort(newData, 'memberShipName', 'asc', 'memberShipName');
    else if (classSort === 'desc') newData = SortingModule.dataSort(newData, 'memberShipName', 'desc', 'memberShipName');
    
    setSortingData(newData);


    let selectMembershipNames = '';

    for (let i = 0; i < selectedMembership.length; i++) {
      if (i === 0) selectMembershipNames += selectedMembership[i].name;
      else selectMembershipNames += '<-@->' + selectedMembership[i].name; 
    }

    window.localStorage.setItem('InvalidMemberGenderSort', genderSort);
    window.localStorage.setItem('InvalidMemberBirthSort', birthSort);
    window.localStorage.setItem('InvalidMemberStartSort', startSort);
    window.localStorage.setItem('InvalidMemberEndSort', endSort);
    window.localStorage.setItem('InvalidMemberClassSort', classSort);
    window.localStorage.setItem('InvalidMemberMembershipNames', selectMembershipNames);
  }, [totalData, selectedMembership, genderSort, birthSort, startSort, endSort, classSort])

  // 검색 기능 포함 ( 한글 검색 알고리즘 최신화 ) //
  useEffect(() => {
    var nameList = [];
    var phoneList = [];

    for (var i = 0; i < sortingData.length; i++) {
      if (sortingData[i].name.toLowerCase().includes(value.toLowerCase())) nameList.push(sortingData[i]);
      else if (sortingData[i].phone.includes(value)) phoneList.push(sortingData[i]);
    }

    if (nameList.length === 0 && phoneList.length === 0) {
      for (var i = 0; i < sortingData.length; i++) {
        if (match(value.toLowerCase(), sortingData[i].name.toLowerCase())) nameList.push(sortingData[i]);
      }
    }

    var totalList = nameList.concat(phoneList);
    var newDataList = [];

    // 페이지 분리 //
    if (totalList.length !== 0) {
      if (totalList.length > 20) newDataList = totalList.slice((nowPage * 20), (nowPage * 20) + 20);
      else newDataList = totalList.slice();
    }

    setDividedData(newDataList);
    setIsSettled(true);
  }, [nowPage, sortingData, value, match()])

  // 입력된 글자가 한글인지 확인 //
  function is_kr(value) {
    if (value === undefined) return false;
    
    return ((('ㄱ'.charCodeAt() <= value.charCodeAt()) && (value.charCodeAt() <= 'ㅎ'.charCodeAt()))
            || (('가'.charCodeAt() <= value.charCodeAt()) && value.charCodeAt() <= '힣'.charCodeAt()));
  }

  // 한글 글자 유니코드 추출하여 검색 조건 확인 //
  function kr_num(value) {
    return value.charCodeAt() - '가'.charCodeAt();
  }

  // 초성 중성 종성 구분하여 연산 //
  function kr_list(value) {
    var consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                        , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    var res = [value];

    var kr_num_s = kr_num(value);

    if (kr_num_s > 0) {
      // 초성 + 중성일 경우 //
      if (kr_num_s % 28 !== 0) {
        res.push(String.fromCharCode(((parseInt(kr_num_s / 28) * 28) + '가'.charCodeAt())));
      }
      
      res.push(consonant_list[parseInt(kr_num_s / 588)])
    }

    return res;
  }

  // 한글, 영어 구분하여 검색 처리 //
  function eq_kr(value, data) {
    if (is_kr(value) && is_kr(data)) {
      return kr_list(data).includes(value);
    }
    else return value === data;
  }

  // 받침 확인하기 //
  function eq_kr_pos(value, data, nextData) {
    var consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                        , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    var kr_pos = [
      [0, 0], [1, 0], [2, 1], [2, 9], [4, 2], [1, 12], [2, 18],
      [7, 3], [8, 5], [1, 0], [2, 6], [3, 7], [4, 9], [5, 16],
      [6, 17], [7, 18], [16, 6], [17, 7], [1, 9], [19, 9], [20, 10],
      [21, 11], [22, 12], [23, 14], [24, 15], [25, 16], [26, 17], [27, 18]
    ]

    if (!(is_kr(value) && is_kr(data) && is_kr(nextData))) return false;
    if (kr_num(value) < 0) return false;
    
    var s_pos = String.fromCharCode(value.charCodeAt() - kr_pos[kr_num(value) % 28][0])
    var s_pos_consonant = consonant_list[kr_pos[kr_num(value) % 28][1]]

    return (s_pos === data) && (kr_list(nextData).includes(s_pos_consonant));
  }

  // 일치하는 글자가 존재하는지 확인 //
  function match(value, data) {
    if (value === undefined || data === undefined) return false;

    var valueSize = value.length;
    var dataSize = data.length;

    if (dataSize < valueSize) return false;

    for (var i = 0; i < (dataSize - valueSize + 1); i++) {
      var res = true;

      for (var j = 0; j < valueSize; j++) {
        if (j === (valueSize - 1)) {
          if (!eq_kr(value[j], data[i + j])) {
            if (i + j + 1 < dataSize) {
              if (eq_kr_pos(value[j], data[i + j], data[i + j + 1])) {
                break;
              }
            }
            res = false;
            break;
          }
        }
        else {
          if (value[j] !== data[i + j]) {
            res = false;
            break;
          }
        }
      }

      if (res) return true;
    }

    return false;
  }

  function onClickNextPage() {
    if (nowPage + 1 < Math.ceil(sortingData.length/20)) setNowPage(nowPage + 1);
  }

  function onClickPrevPage() {
    if ((nowPage - 1) >= 0) setNowPage(nowPage - 1);  
  }

  return (
    <TopLevelWrapper>
      <TopBarWrapper>
        <TextWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('expiredMember.title')}</Text>
            <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('validMember.totalCount').replace('{count}', data.length)}</Text>
          </TitleWrapper>
          <SubTitleWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('expiredMember.description')}</Text>
          </SubTitleWrapper>
        </TextWrapper>
        <SearchInput value={value} setValue={setValue} placeholder={t('validMember.searchPlaceholder')} />
      </TopBarWrapper>
      <ExpiredColumnView 
        selectedMembership={selectedMembership}
        setSelectedMembership={setSelectedMembership} 
        genderSort={genderSort}
        setGenderSort={setGenderSort}
        birthSort={birthSort}
        setBirthSort={setBirthSort}
        startSort={startSort}
        setStartSort={setStartSort}
        endSort={endSort}
        setEndSort={setEndSort}
        classSort={classSort}
        setClassSort={setClassSort}/>
      {
        (isLoading || !isSettled) ?
          <ViewBox>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
          </ViewBox>
          :
          <ViewBox $isFlexStart={dividedData.length > 0}>
            {
              dividedData.length === 0 ?
                <InfoBox>
                  <EmptyLogoWrapper>
                    <EmptyLogoView />
                    <EmptyText>{t('validMember.empty')}</EmptyText>
                  </EmptyLogoWrapper>
                </InfoBox>
                :
                <InfoBox>
                  {
                    dividedData.map((data, index) => (
                      <ExpiredMemberInfo key={index} data={data} nowPage={nowPage} />
                    ))
                  }
                </InfoBox>
            }
          </ViewBox>
      }
      <PaginationWrapper>
        <InfoPagination
          nowPage={nowPage}
          totalPage={Math.ceil(sortingData.length / 20)}
          nextClickFn={onClickNextPage}
          prevClickFn={onClickPrevPage} />
      </PaginationWrapper>
    </TopLevelWrapper>
  )
})

export default ExpiredMemberView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  margin-left: 10px;

  width: 970px;

  transition: all 0.3s ease-in-out;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-left: 20px;

  height: 82px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  height: 24px;

  gap: 4px;
`;

const SubTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 38px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: ${props => props.$isFlexStart ? 'flex-start' : 'center'};

  width: 100%;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 150px 0 150px 0;

  width: 160px;
  height: 160px;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const EmptyLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 135px;
  margin-bottom: 135px;
`;

const EmptyLogoView = styled(DefaultLogoSvg)`
  width: 180px;
  height: 180px;

  margin-bottom: 20px;

  & path:nth-child(1) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(2) { fill: ${props => props.theme.logo2}; }
  & path:nth-child(3) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(4) { fill: ${props => props.theme.logo3}; }
`;

const EmptyText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;

  color: ${props => props.theme.buttonStroke};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  margin-top: 44px;
`;

const Text = styled.span`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
